var _classCallCheck = require("/vercel/path0/node_modules/@babel/runtime/helpers/classCallCheck.js").default;
var _createClass = require("/vercel/path0/node_modules/@babel/runtime/helpers/createClass.js").default;
var _inherits = require("/vercel/path0/node_modules/@babel/runtime/helpers/inherits.js").default;
var _createSuper = require("/vercel/path0/node_modules/@babel/runtime/helpers/createSuper.js").default;
var _require = require('eth-util-lite'),
  decode = _require.decode,
  toBuffer = _require.toBuffer;
var EthObject = require('./ethObject');
var Log = /*#__PURE__*/function (_EthObject) {
  "use strict";

  _inherits(Log, _EthObject);
  var _super = _createSuper(Log);
  function Log() {
    var raw = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Log.NULL;
    _classCallCheck(this, Log);
    return _super.call(this, Log.fields, raw);
  }
  _createClass(Log, null, [{
    key: "fields",
    get: function get() {
      return ['address', 'topics', 'data'];
    }
  }, {
    key: "fromBuffer",
    value: function fromBuffer(buf) {
      return buf ? new Log(decode(buf)) : new Log();
    }
  }, {
    key: "fromHex",
    value: function fromHex(hex) {
      return hex ? new Log(decode(hex)) : new Log();
    }
  }, {
    key: "fromRaw",
    value: function fromRaw(raw) {
      return new Log(raw);
    }
  }, {
    key: "fromObject",
    value: function fromObject(rpcResult) {
      return Log.fromRpc(rpcResult);
    }
  }, {
    key: "fromRpc",
    value: function fromRpc(rpcResult) {
      var topics = [];
      //.map
      for (var i = 0; i < rpcResult.topics.length; i++) {
        topics.push(toBuffer(rpcResult.topics[i]));
      }
      return new Log([toBuffer(rpcResult.address), topics, toBuffer(rpcResult.data)]);
    }
  }]);
  return Log;
}(EthObject);
module.exports = Log;